import * as API_LINKS from '../config/links'
import axios from "axios";

export const FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM = 'FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM'
export const RECEIVE_WORK_ORDERS_STOCKER_INBOUND_ITEM = 'RECEIVE_WORK_ORDERS_STOCKER_INBOUND_ITEM'
export const FAILED_WORK_ORDERS_STOCKER_INBOUND_ITEM = 'FAILED_WORK_ORDERS_STOCKER_INBOUND_ITEM'

export const FETCH_WORK_ORDERS_STOCKER_OUTBOUND_ITEM = 'FETCH_WORK_ORDERS_STOCKER_OUTBOUND_ITEM'
export const RECEIVE_WORK_ORDERS_STOCKER_OUTBOUND_ITEM = 'RECEIVE_WORK_ORDERS_STOCKER_OUTBOUND_ITEM'
export const FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM = 'FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM'

const TEMPORARY_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxMjgsImVtYWlsIjoiYWNjb3VudF9kZW1vQGF1dG9tYS5jb20iLCJuYW1lIjoiRGVtbyIsImNvbXBhbnkiOjI2LCJjb21wYW55X25hbWUiOiJBY2NvdW50IERlbW8iLCJjb21wYW55X3Bob25lIjoiNjI4OTY3MjA1NTk1MSIsInJvbGVzX2lkIjo0LCJyb2xlcyI6IlN1cGVyIEFkbWluIiwiaWF0IjoxNjY4MjIzNzU1LCJleHAiOjE5ODM1ODM3NTV9.b4mICdSBRE0Mlk1v8f6lvsAdJSds6jlV3nQcpKJsCX8"

export function fetchWorkOrdersStockerOutboundItemByWoTable(workOrdersTableData, key){
    // console.log(auth)
    return (dispatch, getState) => {
        dispatch({type: FETCH_WORK_ORDERS_STOCKER_OUTBOUND_ITEM});
        let fetchOutbounds= []
        let outItemResult = {}
        workOrdersTableData.forEach(wo => {
            let idStockerOutbound = wo.id_stocker_outbound_saved? wo.id_stocker_outbound_saved : 
            wo.work_order_from? wo.work_order_from.id_outbound_stocker : null
            if(!idStockerOutbound)
                return
            outItemResult[idStockerOutbound] = []
            fetchOutbounds.push(
                axios({
                    method: 'post',
                    url: API_LINKS.WORK_ORDER_STOCKER_OUTBOUND_ITEM,
                    headers: {
                        Authorization: TEMPORARY_KEY
                    },
                    data: {
                        id_work_order: wo.id? wo.id: wo.work_order_from? wo.work_order_from.id : null
                        // date: 
                        // For Parameters
                    }
                })
            )
        })
        Promise.all([...fetchOutbounds])
        .then((responses) => {
            responses.forEach((r)=> {
                let idMasterOutbound = r.data.result[0]? r.data.result[0].id_master_outbound : null
                if(!idMasterOutbound)
                    return
                outItemResult[idMasterOutbound] = [...r.data.result]
            })
            dispatch( {
                type: RECEIVE_WORK_ORDERS_STOCKER_OUTBOUND_ITEM,
                payload: outItemResult
            })
        })
    //     .catch(function(error){
    //         console.log(error)
    //         if (error.response) {
    //             if(error.response.status === 401) {
    //                 dispatch({
    //                     type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //                 })
    //                 return toast.error("Invalid username or password! Please try again!");
    //             } else if (error.response.status === 404 || error.response.status === 500) {
    //                 dispatch({
    //                     type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //                 })
    //                 return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
    //             } else if (error.response.status === 400) {
    //                 dispatch({
    //                     type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //                 })
    //                 return toast.error(error.response.data.message);
    //             } else {
    //                 dispatch({
    //                     type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //                 })
    //                 return toast.error('Something went wrong... Please try again later...');
    //             }
    //         } else if (error.request) {
    //             dispatch({
    //                 type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //             })
    //             return toast.error('Request error! Please try again later...')
    //         } else {
    //             dispatch({
    //                 type: FAILED_WORK_ORDERS_STOCKER_OUTBOUND_ITEM
    //             })
    //             return toast.error('Something went wrong... Please try again later...')
    //         }

    //     })
    }
}

export function fetchWorkOrdersStockerInboundItemByWoTable(workOrdersTableData, key){
    // console.log(auth)
    return (dispatch, getState) => {
        dispatch({type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM});
        let fetchInbounds = []
        let inbItemResult = {}
        workOrdersTableData.forEach(wo => {
            let idStockerInbound= wo.id_stocker_inbound_saved? wo.id_stocker_inbound_saved : 
                    wo.work_order_from? wo.work_order_from.id_inbound_stocker : null
            if(!idStockerInbound)
                return
            inbItemResult[idStockerInbound]=[]
            fetchInbounds.push(
                axios({
                    method: 'post',
                    url: API_LINKS.WORK_ORDER_STOCKER_INBOUND_ITEM,
                    headers: {
                        Authorization: TEMPORARY_KEY
                    },
                    data: {
                        id_work_order: wo.id? wo.id: wo.work_order_from? wo.work_order_from.id : null
                        // date: 
                        // For Parameters
                    }
                })
            )
        })
        Promise.all([...fetchInbounds])
        .then((responses) => {
            responses.forEach((r,i)=> {
                let idMasterinbound = r.data.result[0]? r.data.result[0].id_master_inbound : null
                if(!idMasterinbound)
                    return
                inbItemResult[idMasterinbound] = [...r.data.result]
            })
            dispatch( {
                type: RECEIVE_WORK_ORDERS_STOCKER_INBOUND_ITEM,
                payload: inbItemResult
            })
        })
        // .catch(function(error){
        //     console.log(error)
        //     if (error.response) {
        //         if(error.response.status === 401) {
        //             dispatch({
        //                 type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //             })
        //             return toast.error("Invalid username or password! Please try again!");
        //         } else if (error.response.status === 404 || error.response.status === 500) {
        //             dispatch({
        //                 type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //             })
        //             return toast.error("Failed in fetching Work Orders List. Server cannot be contacted! Please ask your system administrator!");
        //         } else if (error.response.status === 400) {
        //             dispatch({
        //                 type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //             })
        //             return toast.error(error.response.data.message);
        //         } else {
        //             dispatch({
        //                 type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //             })
        //             return toast.error('Something went wrong... Please try again later...');
        //         }
        //     } else if (error.request) {
        //         dispatch({
        //             type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //         })
        //         return toast.error('Request error! Please try again later...')
        //     } else {
        //         dispatch({
        //             type: FETCH_WORK_ORDERS_STOCKER_INBOUND_ITEM
        //         })
        //         return toast.error('Something went wrong... Please try again later...')
        //     }

        // })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/aTransporter-WoStocker.jsx